module.exports = __webpack_public_path__ + "media/reskin-images/playbook-full-logo-af81ee65.png";